import { Chakra } from "@airhelp/react-ui-components";
import config from "config/config";
import { useTranslations } from "contexts/LocalizationContext";
import { trackEvents } from "utils/trackingUtils";
import {
  WHY_CHOOSE_AH_CHECK_COMPENSATION_GTM,
  WHY_CHOOSE_AH_CHECK_COMPENSATION_MP,
  positiveItems,
  negativeItems,
} from "./config";
import ItemsList from "./ItemsList";
import ListWrapper from "./ListWrapper";
import NegativeItem from "./NegativeItem";
import PositiveItem from "./PositiveItem";

const { Stack, Divider, Heading, Button } = Chakra;

const WhyChooseAHLists = () => {
  const translations = useTranslations();
  const trackingEvents = {
    gtmEvent: WHY_CHOOSE_AH_CHECK_COMPENSATION_GTM,
    mixpanelEvent: WHY_CHOOSE_AH_CHECK_COMPENSATION_MP,
  };

  return (
    <Stack
      direction={{ base: "column", md: "row" }}
      spacing={{ base: 8, md: 4, lg: 8 }}
      justify={{ base: "left", md: "center" }}
      align="flex-start"
      maxW={{ base: "full", lg: "936px" }}
    >
      <ListWrapper bg={{ base: "none", md: "greyscale.300" }}>
        <Heading variant="h4" as="h4" mb={{ base: 6, md: 8 }}>
          {translations("why_airhelp_claim_by_yourself")}
        </Heading>
        <Divider mb={8} display={{ base: "none", md: "block" }} />
        <ItemsList>
          {negativeItems.map((item) => (
            <NegativeItem key={item.headingTranslationKey} item={item} />
          ))}
        </ItemsList>
      </ListWrapper>

      <ListWrapper bg={{ base: "none", md: "white" }}>
        <Heading variant="h4" as="h4" mb={{ base: 6, md: 8 }}>
          {translations("why_airhelp_use_airhelp")}
        </Heading>
        <Divider mb={8} display={{ base: "none", md: "block" }} />
        <ItemsList>
          {positiveItems.map((item) => (
            <PositiveItem key={item.headingTranslationKey} item={item} />
          ))}
        </ItemsList>
        <Button mt={8} as="a" href={`${config.funnelUrl}/claims/new/`} onClick={() => trackEvents(trackingEvents)}>
          {translations("check_compensation")}
        </Button>
      </ListWrapper>
    </Stack>
  );
};

export default WhyChooseAHLists;
